import { useDispatchTool, useStateTool } from 'app/store/withDevTools';
import React from 'react';
import { transportadoraReducer, initialState } from './transportadoraReducer';
/**
 * baseado em
 *
 * https://kentcdodds.com/blog/how-to-use-react-context-effectively
 * https://kentcdodds.com/blog/how-to-optimize-your-context-value
 */
const TransportadoraStateContext = React.createContext();
const TransportadoraDispatchContext = React.createContext();

function TransportadoraProvider(props) {
  const [state, dispatch] = React.useReducer(transportadoraReducer, initialState);

  return (
    <TransportadoraStateContext.Provider value={state}>
      <TransportadoraDispatchContext.Provider value={dispatch}>{props.children}</TransportadoraDispatchContext.Provider>
    </TransportadoraStateContext.Provider>
  );
}

function TransportadoraConsumer({ children }) {
  return (
    <TransportadoraStateContext.Consumer>
      {(context) => {
        if (context === undefined) {
          throw new Error('TransportadoraConsumer must be used within a TransportadoraProvider');
        }
        return children(context);
      }}
    </TransportadoraStateContext.Consumer>
  );
}

function useTransportadora() {
  return [
    useStateTool(TransportadoraStateContext, 'TransportadoraStateContext'),
    useDispatchTool(TransportadoraDispatchContext, 'TransportadoraDispatchContext'),
  ];
}

export { TransportadoraProvider, TransportadoraConsumer, useTransportadora };
